import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import {
  INewNotificationsAxiosResponse,
  INewNotificationsCountRequest,
  INewNotificationsRequest,
  INotificationAxiosResponse,
  INotificationCountAxiosResponse,
  INotificationInAppObraAxiosResponse,
  INotificationInAppObrasAxiosResponse,
  INotificationInAppTopicsAxiosResponse
} from './interfaces/Notification/INotification';
import {
  IPreferencesRequest,
  IPreferences,
  IPreferencesResponse,
  IPreferencesEmailResponse
} from './interfaces/Preferences/IPreferencesApi';

export class NotificationApiV2 {
  static async countNewNotifications(request?: INewNotificationsCountRequest): Promise<AxiosResponse<INotificationCountAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get(`/v2/notifications/new/count${request?.constructionSiteId ? `?constructionSiteId=${request.constructionSiteId}` : ''}${request?.personalOnly ? `?personalOnly=${request.personalOnly}` : ''}`);
  }

  static async listNewNotifications(request: INewNotificationsRequest): Promise<AxiosResponse<INewNotificationsAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get(`/v2/notifications/new?pageNumber=${request?.pageNumber ?? 1}&pageSize=${request?.pageSize ?? 10}${request?.constructionSiteId ? `&constructionSiteId=${request.constructionSiteId}` : ''}${request?.personalOnly ? `&personalOnly=${request.personalOnly}` : ''}`);
  }

  static async listNotifications(request: INewNotificationsRequest): Promise<AxiosResponse<INotificationAxiosResponse>> {
    const axios = await Http.axios();
    return axios.post(`/v2/notifications?pageNumber=${request?.pageNumber ?? 1}&pageSize=${request?.pageSize ?? 10}`, request.filters);
  }

  static async readNotification(notificationId: string): Promise<AxiosResponse<void>> {
    const axios = await Http.axios();
    return axios.post(`/v2/notifications/read/${notificationId}`);
  }

  static async readMultipleNotifications(notificationIds: string[]): Promise<AxiosResponse<void>> {
    const axios = await Http.axios();
    return axios.post(`/v2/notifications/read/multiple`, { notificationIds });
  }

  static async readAllNotifications(constructionSiteId?: number | null): Promise<AxiosResponse<void>> {
    const axios = await Http.axios();
    return axios.post(`/v2/notifications/read/all${constructionSiteId ? `?constructionSiteId=${constructionSiteId}` : ''}`);
  }

  static async listInAppObraNotifications(constructionSiteId: number): Promise<AxiosResponse<INotificationInAppObraAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get(`/v2/notifications/construction-sites/${constructionSiteId}/folder-with-new`);
  }

  static async countInAppObrasNotifications(): Promise<AxiosResponse<INotificationInAppObrasAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get("/v2/notifications/construction-sites/with-new");
  }

  static async listInAppTopicNotifications(constructionSiteId: number): Promise<AxiosResponse<INotificationInAppTopicsAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get(`/v2/notifications/construction-sites/${constructionSiteId}/topics/with-new`);
  }

  static async listPreferences(): Promise<AxiosResponse<IPreferencesResponse>> {
    const axios = await Http.axios();
    return axios.get("/v2/notifications/preferences");
  }

  static async createFilePreferences(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/file-preferences", request);
  }

  static async createTopicPreferences(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/topic-preferences", request);
  }

  static async createPlottingPreferences(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/plotting-preferences", request);
  }

  static async listPreferencesEmail(): Promise<AxiosResponse<IPreferencesEmailResponse>> {
    const axios = await Http.axios();
    return axios.get("/v2/notifications/email-preferences");
  }

  static async createFilePreferencesEmail(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/file-preferences-email", request);
  }

  static async createTopicPreferencesEmail(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/topic-preferences-email", request);
  }

  static async createPlottingPreferencesEmail(request: IPreferencesRequest): Promise<AxiosResponse<IPreferences>> {
    const axios = await Http.axios();
    return axios.post("/v2/notifications/plotting-preferences-email", request);
  }
}
